import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i7$1 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i1$1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i5 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i7 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i9 from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { throwError, catchError } from 'rxjs';
import * as i1 from '@angular/common/http';
import { PokemonClient } from 'pokenode-ts';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
function AgeByNameComponent_p_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" OMG ", ctx_r0.name, ", you must be ", ctx_r0.age, " years old! ");
  }
}
function UsernameGeneratorComponent_ng_container_19_mat_chip_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-chip-option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const username_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", username_r1 || "Loading...", " ");
  }
}
function UsernameGeneratorComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "mat-chip-set");
    i0.ɵɵtemplate(3, UsernameGeneratorComponent_ng_container_19_mat_chip_option_3_Template, 2, 1, "mat-chip-option", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cdkVirtualForOf", ctx_r1.result);
  }
}
let CommonUtils = /*#__PURE__*/(() => {
  class CommonUtils {
    static {
      this.handleError = error => {
        if (error.status === 0) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.message, error.error);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong.
          console.error(`Backend returned code ${error.status}, body was: `, error.error);
        }
        // Return an observable with a user-facing error message.
        return throwError(() => new Error(`Something bad happened; please try again later. ${error.type} Error Message: ${error.message} `));
      };
    }
  }
  return CommonUtils;
})();
let EverythingBaseComponent = /*#__PURE__*/(() => {
  class EverythingBaseComponent {
    constructor() {
      this.completionMsgChange = new EventEmitter();
      this.style = {};
    }
    ngOnInit() {
      this.height = this.height ? this.height : '0';
      this.width = this.width ? this.width : '0';
      this.style = {
        height: `${this.height}rem`,
        width: `${this.width}rem`
      };
    }
    static {
      this.ɵfac = function EverythingBaseComponent_Factory(t) {
        return new (t || EverythingBaseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EverythingBaseComponent,
        selectors: [["lib-everything-base"]],
        inputs: {
          height: "height",
          width: "width"
        },
        outputs: {
          completionMsgChange: "completionMsgChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        template: function EverythingBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1, "everything-base works!");
            i0.ɵɵelementEnd();
          }
        }
      });
    }
  }
  return EverythingBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NasaComponent = /*#__PURE__*/(() => {
  class NasaComponent extends EverythingBaseComponent {
    constructor(http) {
      super();
      this.http = http;
    }
    ngOnInit() {
      this.getNasaAPOD();
    }
    getNasaAPOD() {
      let picOfTheDay = undefined;
      if (this.apiKey) {
        this.http.get(`https://api.nasa.gov/planetary/apod?api_key=${this.apiKey}`).pipe(catchError(CommonUtils.handleError)).subscribe({
          next: resp => {
            picOfTheDay = resp;
            this.nasaTitle = picOfTheDay?.title;
            this.nasaDesc = picOfTheDay?.explanation;
            this.nasaImg = picOfTheDay?.url;
          },
          error: err => {
            console.error(err);
            this.completionMsgChange.emit(JSON.stringify(err));
          },
          complete: () => {
            this.completionMsgChange.emit('Success');
          }
        });
      } else {
        this.completionMsgChange.emit('No Name Given');
      }
    }
    get nasaTitle() {
      return this._nasaTitle;
    }
    set nasaTitle(title) {
      this._nasaTitle = title;
    }
    get nasaDesc() {
      return this._nasaDesc;
    }
    set nasaDesc(description) {
      this._nasaDesc = description;
    }
    get nasaImg() {
      return this._nasaImg;
    }
    set nasaImg(imgUrl) {
      this._nasaImg = imgUrl;
    }
    static {
      this.ɵfac = function NasaComponent_Factory(t) {
        return new (t || NasaComponent)(i0.ɵɵdirectiveInject(i1.HttpClient));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NasaComponent,
        selectors: [["lib-nasa"]],
        inputs: {
          apiKey: "apiKey"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 3,
        consts: [["appearance", "outlined", 1, "nasa"], ["mat-card-image", "", "id", "nasa-img", "alt", "nasa img of the day", 3, "src"]],
        template: function NasaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card", 0)(1, "mat-card-header")(2, "mat-card-title");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-card-content");
            i0.ɵɵelement(5, "img", 1);
            i0.ɵɵelementStart(6, "p");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.nasaTitle);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("src", ctx.nasaImg, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.nasaDesc);
          }
        },
        dependencies: [i2.MatCard, i2.MatCardContent, i2.MatCardHeader, i2.MatCardImage, i2.MatCardTitle],
        styles: [".nasa[_ngcontent-%COMP%]{max-height:70rem;min-width:20rem;overflow-y:scroll}#nasa-img[_ngcontent-%COMP%]{max-height:50rem;max-width:75vw}@media (max-width: 430px){mat-mdc-card[_ngcontent-%COMP%]{max-width:26.5rem}}@media (max-width: 390px){mat-mdc-card[_ngcontent-%COMP%]{min-width:21.25rem;max-width:21.25rem}}@media (max-width: 375px){mat-mdc-card[_ngcontent-%COMP%]{min-width:22rem;max-width:22rem}}@media (max-width: 320px){mat-mdc-card[_ngcontent-%COMP%]{min-width:19rem;max-width:19rem}}"]
      });
    }
  }
  return NasaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PokemonComponent = /*#__PURE__*/(() => {
  class PokemonComponent extends EverythingBaseComponent {
    ngOnInit() {
      this.getPokemonOfTheDay();
    }
    get pokemonName() {
      return this._pokemonName;
    }
    set pokemonName(value) {
      this._pokemonName = value;
    }
    async getPokemonOfTheDay() {
      const client = new PokemonClient({
        cacheOptions: {
          ttl: 1000 * 60 * 5
        }
      });
      this.randomId = Math.ceil(Math.random() * 12344321908) % 914;
      try {
        let pokemon = await client.getPokemonById(this.randomId);
        this.pokemonName = pokemon.name.toUpperCase();
        this.pokemonImage = pokemon.sprites.other ? pokemon.sprites.other['official-artwork']?.front_default : '../assets/noun-missing-2181345.svg';
        this.completionMsgChange.emit('Success');
      } catch (error) {
        console.error(error);
        this.completionMsgChange.emit('No Name Given');
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵPokemonComponent_BaseFactory;
        return function PokemonComponent_Factory(t) {
          return (ɵPokemonComponent_BaseFactory || (ɵPokemonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(PokemonComponent)))(t || PokemonComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PokemonComponent,
        selectors: [["lib-pokemon"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 5,
        consts: [["appearance", "outlined", 1, "nasa", 3, "ngStyle"], ["id", "pokemon-img", 3, "src", "alt"], [2, "margin", "0"]],
        template: function PokemonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card", 0)(1, "mat-card-header")(2, "mat-card-title");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-card-content");
            i0.ɵɵelement(5, "img", 1);
            i0.ɵɵelementStart(6, "p", 2);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", ctx.style);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("Who's that pokemon?: ", ctx.pokemonName, "!! ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("src", ctx.pokemonImage, i0.ɵɵsanitizeUrl)("alt", "pokemon number" + ctx.randomId + " " + ctx.pokemonName);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("NUMBER: ", ctx.randomId, "");
          }
        },
        dependencies: [i3.NgStyle, i2.MatCard, i2.MatCardContent, i2.MatCardHeader, i2.MatCardTitle],
        styles: ["#pokemon-img[_ngcontent-%COMP%]{max-height:50rem;max-width:75vw}"]
      });
    }
  }
  return PokemonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AgeByNameComponent = /*#__PURE__*/(() => {
  class AgeByNameComponent extends EverythingBaseComponent {
    constructor(fb, http) {
      super();
      this.fb = fb;
      this.http = http;
      this.ageFromName = this.fb.group({
        name: ['']
      });
    }
    ngOnInit() {
      this.height = this.height ? this.height : '0';
      this.width = this.width ? this.width : '0';
      this.style = {
        height: `${this.height}rem`,
        width: `${this.width}rem`
      };
    }
    getAgeFromName(event) {
      this.name = this.ageFromName.get('name')?.value;
      if (this.name) {
        this.http.get(`https://api.agify.io/?name=${this.name}`).pipe(catchError(CommonUtils.handleError)).subscribe({
          next: resp => {
            this.name = resp.name;
            this.age = resp.age;
          },
          error: err => {
            console.error(err);
            this.completionMsgChange.emit(JSON.stringify(err));
          },
          complete: () => {
            this.completionMsgChange.emit('Success');
          }
        });
      } else {
        this.completionMsgChange.emit('No Name Given');
      }
    }
    get name() {
      return this._name;
    }
    set name(value) {
      this._name = value;
    }
    get age() {
      return this._age;
    }
    set age(value) {
      this._age = value;
    }
    static {
      this.ɵfac = function AgeByNameComponent_Factory(t) {
        return new (t || AgeByNameComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i1.HttpClient));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AgeByNameComponent,
        selectors: [["lib-age-by-name"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 13,
        vars: 3,
        consts: [["appearance", "outlined", "id", "agify", 3, "ngStyle"], ["id", "usr-form", 3, "ngSubmit", "formGroup"], ["matInput", "", "id", "name", "formControlName", "name", "type", "text"], ["mat-raised-button", "", "type", "submit"], [4, "ngIf"]],
        template: function AgeByNameComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card", 0)(1, "mat-card-header")(2, "mat-card-title");
            i0.ɵɵtext(3, " Let me guess your age! ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-card-content")(5, "form", 1);
            i0.ɵɵlistener("ngSubmit", function AgeByNameComponent_Template_form_ngSubmit_5_listener($event) {
              return ctx.getAgeFromName($event);
            });
            i0.ɵɵelementStart(6, "mat-form-field")(7, "mat-label");
            i0.ɵɵtext(8, " \"What's your name?\" ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "button", 3);
            i0.ɵɵtext(11, " Get Your Real Age");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, AgeByNameComponent_p_12_Template, 2, 2, "p", 4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", ctx.style);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formGroup", ctx.ageFromName);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngIf", ctx.age);
          }
        },
        dependencies: [i3.NgIf, i3.NgStyle, i2.MatCard, i2.MatCardContent, i2.MatCardHeader, i2.MatCardTitle, i5.MatFormField, i5.MatLabel, i6.MatInput, i1$1.ɵNgNoValidate, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName, i7.MatButton],
        styles: ["mat-mdc-card[_ngcontent-%COMP%]{width:30rem}@media (max-width: 430px){mat-mdc-card[_ngcontent-%COMP%]{width:25.55rem}}@media (max-width: 390px){mat-mdc-card[_ngcontent-%COMP%]{min-width:21.25rem;max-width:21.25rem}}@media (max-width: 375px){mat-mdc-card[_ngcontent-%COMP%]{min-width:22rem;max-width:22rem}}@media (max-width: 320px){mat-mdc-card[_ngcontent-%COMP%]{min-width:19rem;max-width:19rem}}"]
      });
    }
  }
  return AgeByNameComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BoredomSolverComponent = /*#__PURE__*/(() => {
  class BoredomSolverComponent extends EverythingBaseComponent {
    constructor(http) {
      super();
      this.http = http;
    }
    ngOnInit() {
      this.getActivityTodo();
      this.height = this.height ? this.height : '0';
      this.width = this.width ? this.width : '0';
      this.style = {
        height: `${this.height}rem`,
        width: `${this.width}rem`
      };
    }
    getActivityTodo() {
      this.http.get(`https://www.boredapi.com/api/activity`).pipe(catchError(CommonUtils.handleError)).subscribe({
        next: resp => {
          this.activity = resp.activity;
        },
        error: err => {
          console.error(err);
          this.completionMsgChange.emit(JSON.stringify(err.message));
        },
        complete: () => {
          this.completionMsgChange.emit('Success');
        }
      });
    }
    get activity() {
      return this._activity;
    }
    set activity(value) {
      this._activity = value;
    }
    static {
      this.ɵfac = function BoredomSolverComponent_Factory(t) {
        return new (t || BoredomSolverComponent)(i0.ɵɵdirectiveInject(i1.HttpClient));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BoredomSolverComponent,
        selectors: [["lib-boredom-solver"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 2,
        consts: [["appearance", "outlined", 3, "ngStyle"]],
        template: function BoredomSolverComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card", 0)(1, "mat-card-header")(2, "mat-card-title");
            i0.ɵɵtext(3, "Bored?? Well, you should: ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-card-content");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", ctx.style);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", ctx.activity, " ");
          }
        },
        dependencies: [i3.NgStyle, i2.MatCard, i2.MatCardContent, i2.MatCardHeader, i2.MatCardTitle],
        styles: ["mat-mdc-card-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}@media (max-width: 430px){mat-mdc-card[_ngcontent-%COMP%]{min-width:25.55rem;max-width:25.55rem}}@media (max-width: 390px){mat-mdc-card[_ngcontent-%COMP%]{min-width:21.25rem;max-width:21.25rem}}@media (max-width: 375px){mat-mdc-card[_ngcontent-%COMP%]{min-width:22rem;max-width:22rem}}@media (max-width: 320px){mat-mdc-card[_ngcontent-%COMP%]{min-width:19rem;max-width:19rem}}"]
      });
    }
  }
  return BoredomSolverComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UsernameGeneratorComponent = /*#__PURE__*/(() => {
  class UsernameGeneratorComponent extends EverythingBaseComponent {
    constructor(fb, httpClient) {
      super();
      this.fb = fb;
      this.httpClient = httpClient;
      this.usernameFormChange = new EventEmitter();
      this.resultChange = new EventEmitter();
      this.resultChange.emit(this.result);
    }
    // get results() {
    //   return this.result;
    // }
    // set results(result: string[]) {
    //   this.result = result;
    //   this.resultChange.emit(this.result);
    // }
    onSubmit(event) {
      if (this.usernameForm) {
        this.usernameFormChange.emit(this.usernameForm);
        const body = {
          words: (this.usernameForm.get('words')?.value).split(','),
          specials: (this.usernameForm.get('specialCharacters')?.value).split(',')
        };
        this.httpClient.post('https://usernamegeneratorapigen2-e2kmmtsfeq-uc.a.run.app/usernames', body, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }).pipe(catchError(CommonUtils.handleError)).subscribe({
          next: results => {
            this.result = results;
          },
          error: err => {
            console.error(err);
            this.completionMsgChange.emit(JSON.stringify(err));
          },
          complete: () => {
            this.completionMsgChange.emit('Success');
          }
        });
      } else this.completionMsgChange.emit('No Form Given');
    }
    static {
      this.ɵfac = function UsernameGeneratorComponent_Factory(t) {
        return new (t || UsernameGeneratorComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i1.HttpClient));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UsernameGeneratorComponent,
        selectors: [["lib-username-generator"]],
        inputs: {
          usernameForm: "usernameForm",
          result: "result"
        },
        outputs: {
          usernameFormChange: "usernameFormChange",
          resultChange: "resultChange"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 20,
        vars: 2,
        consts: [["appearance", "outlined", "id", "username-gen-card"], ["id", "display-div"], ["id", "usr-form", 3, "ngSubmit", "formGroup"], ["id", "form-div"], ["matInput", "", "formControlName", "words", "type", "text"], ["matInput", "", "formControlName", "specialCharacters", "type", "text"], ["mat-raised-button", "", "type", "submit", "data-sitekey", "reCAPTCHA_site_key", "data-callback", "onSubmit", "data-action", "submit", 1, "g-recaptcha"], ["appendOnly", "", "itemSize", "10", "id", "chip-viewport"], [4, "ngIf"], ["id", "username-result-div"], [4, "cdkVirtualFor", "cdkVirtualForOf"]],
        template: function UsernameGeneratorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card", 0)(1, "mat-card-header")(2, "mat-card-title");
            i0.ɵɵtext(3, " Username Generator ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-card-content")(5, "div", 1)(6, "form", 2);
            i0.ɵɵlistener("ngSubmit", function UsernameGeneratorComponent_Template_form_ngSubmit_6_listener($event) {
              return ctx.onSubmit($event);
            });
            i0.ɵɵelementStart(7, "div", 3)(8, "mat-form-field")(9, "mat-label");
            i0.ɵɵtext(10, " Words To Use ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "input", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "mat-form-field")(13, "mat-label");
            i0.ɵɵtext(14, " Special Characters To Use ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "input", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "button", 6);
            i0.ɵɵtext(17, " Generate Usernames ");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(18, "cdk-virtual-scroll-viewport", 7);
            i0.ɵɵtemplate(19, UsernameGeneratorComponent_ng_container_19_Template, 4, 1, "ng-container", 8);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("formGroup", ctx.usernameForm);
            i0.ɵɵadvance(13);
            i0.ɵɵproperty("ngIf", ctx.result.length > 1);
          }
        },
        dependencies: [i3.NgIf, i2.MatCard, i2.MatCardContent, i2.MatCardHeader, i2.MatCardTitle, i5.MatFormField, i5.MatLabel, i6.MatInput, i7$1.MatChipOption, i7$1.MatChipSet, i1$1.ɵNgNoValidate, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName, i7.MatButton, i9.CdkFixedSizeVirtualScroll, i9.CdkVirtualForOf, i9.CdkVirtualScrollViewport],
        styles: ["mat-mdc-chip-listbox.mat-mdc-chip-listbox[_ngcontent-%COMP%]{overflow:auto;display:flex;justify-content:center;align-items:center}#username-gen-card[_ngcontent-%COMP%], #form-div[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;overflow:auto}#display-div[_ngcontent-%COMP%]{height:15rem;display:flex;flex-direction:row}#username-result-div[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;width:25rem}#chip-viewport[_ngcontent-%COMP%]{min-width:30rem;margin:1rem}#usr-form[_ngcontent-%COMP%]{width:18rem}#form-div[_ngcontent-%COMP%]{padding:1rem}@media (max-width: 430px){#username-result-div[_ngcontent-%COMP%]{flex-direction:column;height:25rem}#chip-viewport[_ngcontent-%COMP%]{width:20rem;height:30rem;margin:1rem}#display-div[_ngcontent-%COMP%]{height:25rem;width:20rem;flex-direction:column}mat-mdc-card#username-gen-card[_ngcontent-%COMP%]{width:25.5rem;max-height:40rem}}@media (max-width: 390px){mat-mdc-card[_ngcontent-%COMP%]{min-width:21.25rem;max-width:21.25rem}}@media (max-width: 375px){mat-mdc-card[_ngcontent-%COMP%]{min-width:22rem;max-width:22rem}}@media (max-width: 320px){mat-mdc-card[_ngcontent-%COMP%]{min-width:19rem;max-width:19rem}}"]
      });
    }
  }
  return UsernameGeneratorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EverythingLibModule = /*#__PURE__*/(() => {
  class EverythingLibModule {
    static {
      this.ɵfac = function EverythingLibModule_Factory(t) {
        return new (t || EverythingLibModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EverythingLibModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCardModule, MatFormFieldModule, MatInputModule, MatChipsModule, FormsModule, ReactiveFormsModule, MatButtonModule, ScrollingModule]
      });
    }
  }
  return EverythingLibModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of everything-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AgeByNameComponent, BoredomSolverComponent, EverythingBaseComponent, EverythingLibModule, NasaComponent, PokemonComponent, UsernameGeneratorComponent };
